import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'

const methods: any = (VueApexCharts as any).methods
if (methods && methods.init) {
  const originalInit = methods.init
  methods.init = function (this: any) {
    if (!this.options || typeof this.options !== 'object' || Array.isArray(this.options)) {
      this.options = {}
    }
    if (!this.options.chart || typeof this.options.chart !== 'object' || Array.isArray(this.options.chart)) {
      this.options.chart = {}
    }
    if (!Array.isArray(this.series)) {
      this.series = []
    }
    const safeType = this.type || this.options.chart.type || 'line'
    if (!this.type && !this.options.chart.type) {
      this.options.chart.type = safeType
    }
    try {
      const result = originalInit.call(this)
      if (result && typeof result.catch === 'function') {
        return result.catch((e: any) => {
          console.error('[apexcharts] render failed', e)
        })
      }
      return result
    } catch (e) {
      console.error('[apexcharts] init failed', e)
      return Promise.resolve()
    }
  }
  const originalUpdateOptions = methods.updateOptions
  if (originalUpdateOptions) {
    methods.updateOptions = function (this: any, ...args: any[]) {
      if (!this.chart) return Promise.resolve()
      try {
        return originalUpdateOptions.apply(this, args)
      } catch (e) {
        console.error('[apexcharts] updateOptions failed', e)
        return Promise.resolve()
      }
    }
  }
  const originalUpdateSeries = methods.updateSeries
  if (originalUpdateSeries) {
    methods.updateSeries = function (this: any, ...args: any[]) {
      if (!this.chart) return Promise.resolve()
      try {
        return originalUpdateSeries.apply(this, args)
      } catch (e) {
        console.error('[apexcharts] updateSeries failed', e)
        return Promise.resolve()
      }
    }
  }
}

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
